import {fromJS} from 'immutable';
import influencerActions from '../actions/influencer.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';

export const DEFAULT_STATE = fromJS({
    socialLinks: [],
    signup: false,
    loading: false,
    verificationSent: false,
    affiliateAccount: {},
    socialChannels: []
});

export const influencerReducer = (state = DEFAULT_STATE, action) => {
    let newState = state;
    switch (action.type) {
        case influencerActions.TYPES.CREATE_INFLUENCER_PROFILE: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }
        case influencerActions.TYPES.CREATE_INFLUENCER_PROFILE_SUCCESS: {
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['signup'], () => true);
            newState = newState.updateIn(['affiliateAccount'], () => action.payload.data);
            return newState;
        }
        case influencerActions.TYPES.CREATE_INFLUENCER_PROFILE_FAILED: {
            if (
                action.payload &&
                action.payload.error &&
                action.payload.error.response &&
                action.payload.error.response.status === 401
            ) {
                newState = DEFAULT_STATE;
            } else {
                newState = newState.updateIn(['loading'], () => false);
            }
            return newState;
        }
        case influencerActions.TYPES.RESEND_EMAIL_VERIFICATION: {
            newState = newState.updateIn(['loading'], () => true);
            newState = newState.updateIn(['verificationSent'], () => true);
            return newState;
        }
        case influencerActions.TYPES.RESEND_EMAIL_VERIFICATION_SUCCESS: {
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['signup'], () => true);
            return newState;
        }
        case influencerActions.TYPES.RESEND_EMAIL_VERIFICATION_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }
        case influencerActions.TYPES.GET_ACCOUNT_SOCIAL_LINKS: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }
        case influencerActions.TYPES.GET_ACCOUNT_SOCIAL_LINKS_SUCCESS: {
            if (action.payload) {
                newState = newState.updateIn(['socialLinks'], () => action.payload);
                newState = newState.updateIn(['loading'], () => false);
            }

            return newState;
        }
        case influencerActions.TYPES.GET_ACCOUNT_SOCIAL_LINKS_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }
        default:
            return state;
    }
};

export default dieselReducer('influencer', influencerReducer);
